import Integration from '~/pages/integration'

export const integration = {
  path: '/integration',
  name: 'Integration',
  pageTitle: 'Integration',
  component: Integration
}
